import { render, staticRenderFns } from "./DocumentListWrapper.vue?vue&type=template&id=3cfb346c&lang=html"
import script from "./DocumentListWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/tukes/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports